import Utils from "../../utility";
import { clearLocal, getUserNameFromLs } from "../../utility/commonFunction";
import { UserType, UserTypeObj } from "../../utility/constant";
export const onSubmit = (values, navigate) => {
  return (dispatch) => {
    const { email, password } = values;
    const dataToSend = {
      username: email,
      password,
    };
    dispatch({
      type: Utils.ActionName.LOADING,
      payload: { loading: true },
    });
    Utils.api.postApiCall(
      Utils.endPoints.login,
      dataToSend,
      (respData) => {
        if (respData?.data?.userType == UserTypeObj.BO) {
          Utils.showAlert(2, `Access denied`);
          dispatch({
            type: Utils.ActionName.LOADING,
            payload: { loading: false },
          });
          return;
        }
        localStorage.setItem("accessToken", respData?.data?.token);
        localStorage.setItem("refreshToken", respData?.data?.refreshToken);
        localStorage.setItem("email", respData?.data?.email);
        Utils.api.getApiCall(
          `${Utils.endPoints.approveUser}${respData?.data?.id}`,
          "",
          (userResp) => {
            const user = userResp?.data;
            if (user?.contactNumber) localStorage.setItem("phone", user.contactNumber);
            if (user?.contactEmail) localStorage.setItem("email", user.contactEmail);
          },
          () => {},
        );
        localStorage.setItem("id", respData?.data?.id);
        localStorage.setItem("username", respData?.data?.userName);
        if (respData?.data?.id == 953)
          localStorage.setItem("userType", `${respData?.data?.userType}_953`);
        else localStorage.setItem("userType", respData?.data?.userType);
        dispatch({
          type: Utils.ActionName.LOADING,
          payload: { loading: false },
        });
        //
        if (
          Utils.constants.B2BUserAccess.includes(respData?.data?.userName) ||
          getUserNameFromLs()?.slice(0, -1) == "category"
        ) {
          //
          navigate("/b2b-po");
          return;
        }
        if (respData?.data?.userType === "CA") {
          navigate("/products");
          return;
        }
        if (["B", "PO"].includes(respData?.data?.userType)) {
          navigate("/store-royalty");
          return;
        }
        if (["BO"].includes(respData?.data?.userType)) {
          navigate("/store-stocks");
          return;
        }
      },
      (error) => {
        let { data } = error;
        dispatch({
          type: Utils.ActionName.LOADING,
          payload: { loading: false },
        });
        Utils.showAlert(
          2,
          `${Utils.endPoints.login} POST Method error ${
            JSON.stringify(data?.message) || data?.error
          }`,
        );
      },
    );
  };
};

export const logout = (navigate) => {
  if (localStorage.getItem("refreshToken") == null) {
    clearLocal();
    navigate("/");
    return;
  }
  return (dispatch) => {
    const dataToSend = {
      refreshToken: localStorage.getItem("refreshToken"),
    };

    Utils.api.postApiCall(
      Utils.endPoints.logout,
      dataToSend,
      (respData) => {
        clearLocal();
        navigate("/");
      },
      (error) => {
        let { data } = error;
        dispatch({
          type: Utils.ActionName.LOADING,
          payload: { loading: false },
        });
        clearLocal();

        navigate("/");
        Utils.showAlert(
          2,
          `${Utils.endPoints.login} POST Method error ${
            JSON.stringify(data?.message) || data?.error
          }`,
        );
      },
    );
  };
};
